import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Button, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PageHeader } from "@ant-design/pro-layout";
import { DeleteOutlined } from "@ant-design/icons";
import {
  InOut,
} from "../../model/model";
import type { GetPageCallbackFunc } from "../../components/DataTable";
import DataTable from "../../components/DataTable";
import SessionStore from "../../model/SessionStore";
import DeleteConfirm from "../../components/DeleteConfirm";

function ListInOuts() {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const deleteInOut = (io: InOut) => {
    SessionStore.getClient().removeInOut(io.id, SessionStore.getBearer()).then(() => {
      messageApi.success("Integration deleted");
      window.location.reload();
    }).catch(err => {
      if (err.status === 401) {
        navigate(`/login`);
      } else {
        messageApi.open({
          type: 'error',
          content: err.message,
        });
      }
    });
  };

  const columns: ColumnsType<InOut> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Link to={`/io/${record.id}`}>{record.name}</Link>
      ),
    },
    {
      title: "Integration",
      dataIndex: "integration",
      key: "integration",
      width: 150,
      render: (text, record) => {
        return record.name;
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_text, record) => (
        <DeleteConfirm confirm={record.name} typ="integration" onConfirm={() => deleteInOut(record)}>
          <Button danger icon={<DeleteOutlined />} />
        </DeleteConfirm>
      ),
    },
  ];

  const getPage = (limit: number, offset: number, callbackFunc: GetPageCallbackFunc) => {
    
    SessionStore.getClient().getAllInOut(SessionStore.getBearer()).then((resp) => {
      callbackFunc(resp.data.length, resp.data);
    });
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      {contextHolder}
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Integrations</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Integrations"
        extra={[
            <Button type="primary">
              <Link to={`/ios/create`}>Add Integration</Link>
            </Button>
        ]}
      />
      <DataTable columns={columns} getPage={getPage} rowKey="id" />
    </Space>
  );
}

export default ListInOuts;
